module.exports = __webpack_public_path__ + "static/media/spring-2019-all.aae84725.jpg";